import React from 'react';
import { Helmet } from 'react-helmet';

export default function BrowserCompatibility() {
  return (
    <Helmet>
      <meta httpEquiv="x-ua-compatible" content="ie=edge" />
      <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
      <meta charset="UTF-8" />
      <meta httpEquiv="cache-control" content="max-age=10800" />
      <meta
        name="viewport"
        content="width=device-width,initial-scale=1,maximum-scale=3,user-scalable=no,shrink-to-fit=no"
      />
      <meta httpEquiv="Cache-Control" content="no-cache, no-store, must-revalidate" />
      <meta httpEquiv="Expires" content="0" />
      <meta httpEquiv="Pragma" content="no-cache" />
    </Helmet>
  );
}
